import { Move } from "../../js/helpers";
import { break_md } from "../../js/constants";

new Move(document.querySelector('[data-move="footer-contact-get"]'), document.querySelector('[data-move="footer-contact-set"]'), break_md).init();